import { UserRole } from '../types/types';

/** Roles that can open News (list/create/edit) in the admin portal. */
export const NEWS_PORTAL_ROLES: UserRole[] = [
    UserRole.Admin,
    UserRole.ProductAdmin,
];
